export const msalConfig = {
  auth: {
    clientId:
      process.env.NODE_ENV === 'production' ? globalThis.__env.REACT_APP_CLIENT_ID : process.env.REACT_APP_CLIENT_ID,
    authority:
      process.env.NODE_ENV === 'production' ? globalThis.__env.REACT_APP_AUTHORITY : process.env.REACT_APP_AUTHORITY // This is a URL
    // (e.g. https://login.microsoftonline.com/{your tenant ID})
    // redirectUri:
    //   process.env.NODE_ENV === 'production' ? globalThis.__env.REACT_APP_REDIRECT_URI : process.env.REACT_APP_REDIRECT_URI
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
  }
}

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: []
}
